import { createContext } from 'react';

export interface ProfileSelectContext {
	selectedProfile?: any;
	setSelectedProfile?: any;
}

export const ProfileSelectContext = createContext<ProfileSelectContext>(null);
